import type { ReactNode } from 'react'
import { OrgPlanHero } from '@/shared/ui/components'
import { cn } from '@/shared/ui/cn'

export type CrewHeroCardProps = {
  testId: string
  title: string
  subtitle: string
  fullBleed?: boolean
  children: ReactNode
}

export function CrewHeroCard({ testId, title, subtitle, fullBleed = false, children }: CrewHeroCardProps) {
  return (
    <section
      data-testid={testId}
      className={cn('overflow-hidden bg-card', fullBleed ? '-mx-4 -mt-12' : 'rounded-xl border')}
    >
      <OrgPlanHero
        heroImage="/crew_hero.jpg"
        tagline={'Your Crew.\nYour Hunt.\nYour Season.'}
        insetTop={fullBleed}
      />
      <div className="flex flex-col gap-4 px-6 py-6">
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-bold leading-tight text-foreground">{title}</h2>
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        </div>
        {children}
      </div>
    </section>
  )
}
